import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import styled from "styled-components";
import { WizardStepper } from "./WizardStepper";
import { Step } from "./Step";
import WizardContext from "./internals/WizardContext";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var Section = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var Wizard = function (_a) {
    var activeStep = _a.activeStep, className = _a.className, completed = _a.completed, totalSteps = _a.totalSteps, children = _a.children, containerStyles = _a.containerStyles, other = __rest(_a, ["activeStep", "className", "completed", "totalSteps", "children", "containerStyles"]);
    var contextValue = useMemo(function () { return ({
        activeStep: activeStep,
        completed: completed,
        totalSteps: totalSteps,
    }); }, [activeStep, completed, totalSteps]);
    return (_jsx(WizardContext.Provider, __assign({ value: contextValue }, { children: _jsx(Container, __assign({ className: className }, other, { children: _jsx(Section, __assign({ style: containerStyles }, { children: children })) })) })));
};
Wizard.Stepper = WizardStepper;
Wizard.Step = Step;
var templateObject_1, templateObject_2;
